module.exports = __webpack_public_path__ + "static/media/pswlogo.52fd8966.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pswlogo.svg
// module id = ./src/images/pswlogo.svg
// module chunks = 2